import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
    Text,
    Title,
    Avatar,
    GridContainer,
    GridItem,
    Tag,
    ContainedButton,
    FileIcon,
    StyledCard,
    StyledCardContent,
} from '../../index';

const PatientCard = ({ data, onDetail }) => {
    const theme = useTheme();

    return (
        <StyledCard padding="0">
            <StyledCardContent>
                <div style={{ display: 'flex', padding: '10px' }}>
                    <div>
                        {data ? (
                            <Avatar
                                alt={data?.user?.fullname}
                                src={data?.user?.avatar?.url}
                                $avatarSize="48px"
                            />
                        ) : (
                            <Skeleton variant="rect" width={64} height={64} />
                        )}
                    </div>
                    <div style={{ display: 'flex', flexGrow: 1 }}>
                        <GridContainer style={{ paddingLeft: '10px', width: '250px' }}>
                            <GridItem justifyContent="flex-start">
                                {data ? (
                                    <Title
                                        style={{
                                            fontSize: '16px',
                                        }}
                                        $ellipsis
                                        $lineHeight="20px"
                                    >
                                        {data?.user?.fullname}
                                    </Title>
                                ) : (
                                    <Skeleton width={200} height={30} variant="text" />
                                )}
                            </GridItem>
                            <GridItem
                                justifyContent="flex-start"
                                style={{ alignSelf: 'flex-end', display: 'flex', columnGap: '5px' }}
                            >
                                {data ? (
                                    !_.isEmpty(data?.patientTag) &&
                                    data.patientTag.map((tag) => <Tag key={tag}>{tag}</Tag>)
                                ) : (
                                    <Skeleton
                                        width={70}
                                        height={30}
                                        variant="text"
                                        style={{ marginRight: '10px' }}
                                    />
                                )}
                            </GridItem>
                        </GridContainer>
                    </div>
                    <div>
                        {onDetail && (
                            <ContainedButton
                                $icon
                                style={{ width: '24px', height: '24px' }}
                                onClick={() => onDetail(data.id)}
                            >
                                <FileIcon />
                            </ContainedButton>
                        )}
                    </div>
                </div>
                {!_.isEmpty(data.patient_summaries) && (
                    <div
                        style={{
                            backgroundColor: theme.palette.common.dimBlue,
                            padding: '10px 15px 15px',
                        }}
                    >
                        <Text $bold $fontSize="12px" style={{ marginBottom: '15px' }}>
                            Latest Note
                        </Text>

                        <Text>{data.patient_summaries[0].noteToPatient}</Text>
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

PatientCard.propTypes = {
    data: PropTypes.object,
    onDetail: PropTypes.func,
};

export default PatientCard;
